import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "@pds-react/grid";
import { fetchService } from "../../../services/fetchService";
import Config from "../../../config";
import { DateTime } from "luxon";
import UserContext from "../../../context/User.context";
import {
  createColumnHelper,
  useReactTable,
  getCoreRowModel,
  flexRender,
  getPaginationRowModel,
} from "@tanstack/react-table";
import Button from "@pds-react/button";
import "./DateFilesReceivedManagement.scss";

import { useNavigate } from "react-router-dom";
import Loading from "../../Loading/Loading";
import Pagination from "../Pagination";
import BasicTable from "../BasicTable";

let columns = [];
const columnHelper = createColumnHelper();

const columnsLong = [
  columnHelper.accessor("DateFilesReceived", {
    header: () => "Date Files Received",
  }),
  columnHelper.accessor("FileType", {
    header: () => "File Type",
  }),
];

const DateFilesReceivedManagement = () => {
  const { baseUrl } = Config.api;
  const { accessToken } = useContext(UserContext);
  const [isloadingDates, setLoadingDates] = useState(true);
  const navigate = useNavigate();
  console.log("Inside Date Files Received Management");

  const [refreshData, setRefreshData] = useState(false);
  columns = columnsLong;

  const [dataDateFilesReceived, setDataDates] = useState([]);

  const [pageViewNum, setPageViewNum] = useState({ value: "", label: "" });

  const tabeDateFilesReceived = useReactTable({
    data: dataDateFilesReceived,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const addDateFileReceived = async (file_type) => {
    const endpoint = `/dateFilesReceived/${file_type}`;
    const postData = {
      DateFilesReceived: DateTime.now().toISODate(),
      fileType: file_type,
    };
    let formattedData = JSON.stringify(postData);

    let response = await fetchService(baseUrl + endpoint, { method: "POST", body: formattedData, token: accessToken });
    if (!response.status.toString().startsWith("2")) {
      throw new Error("Could not add dateFilesReceived");
    }
  };

  const deleteDateFileReceived = async (file_type) => {
    const endpoint = `/dateFilesReceived/${file_type}`;

    let response = await fetchService(baseUrl + endpoint, { method: "DELETE", token: accessToken });
    if (!response.status.toString().startsWith("2")) {
      throw new Error("Could not delete dateFilesReceived");
    }
  };

  const getFileType = (fileNumber) => {
    if (fileNumber == 1) return "DST Account Position (APR) (1)";
    if (fileNumber == 2) return "BNYM STIF Real Time (2)";
    if (fileNumber == 3) return "DST GMM Money Movement (Fund Closing) (3)";
    else return fileNumber;
  };

  const getTableDateFilesReceived = async () => {
    console.log("Trying to get data");
    try {
      setLoadingDates(true);
      let endpoint = "";

      endpoint = `/dateFilesReceived`;
      setLoadingDates(false);

      if (endpoint) {
        let response = await fetchService(baseUrl + endpoint, { method: "GET", token: accessToken });
        let resp = await response.json();
        if (200 !== response.status) {
          throw new Error(resp.requestId);
        }
        setDataDates(
          resp
            .sort(
              (item1, item2) =>
                DateTime.fromISO(item2.DateFilesReceived).toMillis() -
                DateTime.fromISO(item1.DateFilesReceived).toMillis()
            )
            .map((result) => {
              return {
                DateFilesReceived: result.DateFilesReceived,
                FileType: getFileType(result.fileType),
              };
            })
        );
        setLoadingDates(false);
      }
    } catch (error) {
      navigate("/error", { state: { error } });
    }
  };

  const getPageViewOption = (numberOfPages) => {
    let choices = [];
    for (let i = 1; i < numberOfPages + 1; i++) {
      choices.push({ value: i - 1, label: i });
    }
    return choices;
  };

  useEffect(() => {
    (async () => {
      await getTableDateFilesReceived();
    })();
  }, [refreshData]);

  return (
    <div data-testid={"custody-account-management-view"}>
      <Col>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h2>Date Files Received Management</h2>
          </Col>
        </Row>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h3>Stop File from running</h3>
          </Col>
        </Row>
        <Row className="util-margin-top-sm-15 util-margin-top-xs-30">
          <Col sm={4}>
            <Button
              data-testid={"create_apr"}
              id={"create_apr"}
              onClick={async () => {
                await addDateFileReceived(1);
                setRefreshData(!refreshData);
              }}
            >
              DST Account Position (APR) File Received
            </Button>
          </Col>
          <Col sm={4}>
            <Button
              data-testid={"create_bnym"}
              id={"create_bnym"}
              onClick={async () => {
                await addDateFileReceived(2);
                setRefreshData(!refreshData);
              }}
            >
              BNYM STIF Real Time File Received
            </Button>
          </Col>
          <Col sm={4}>
            <Button
              data-testid={"create_fund_closing"}
              id={"create_fund_closing"}
              onClick={async () => {
                await addDateFileReceived(3);
                setRefreshData(!refreshData);
              }}
            >
              DST GMM Money Movement (Fund Closing) File Received
            </Button>
          </Col>
        </Row>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h3>Re-run File</h3>
          </Col>
        </Row>
        <Row className="util-margin-top-sm-15 util-margin-top-xs-30">
          <Col sm={4}>
            <Button
              data-testid={"delete_apr"}
              id={"delete_apr"}
              onClick={async () => {
                await deleteDateFileReceived(1);
                setRefreshData(!refreshData);
              }}
            >
              Delete DST Account Position (APR) File Received
            </Button>
          </Col>
          <Col sm={4}>
            <Button
              data-testid={"delete_bnym"}
              id={"delete_bnym"}
              onClick={async () => {
                await deleteDateFileReceived(2);
                setRefreshData(!refreshData);
              }}
            >
              Delete BNYM STIF Real Time File Received
            </Button>
          </Col>
          <Col sm={4}>
            <Button
              data-testid={"delete_fund_closing"}
              id={"delete_fund_closing"}
              onClick={async () => {
                await deleteDateFileReceived(3);
                setRefreshData(!refreshData);
              }}
            >
              Delete DST GMM Money Movement (Fund Closing) File Received
            </Button>
          </Col>
        </Row>
        <Row>
          <Col data-testid={"header"} id={"header"}>
            <h3>Date Files Received Table</h3>
          </Col>
        </Row>
        {!isloadingDates ? (
          <>
            <Row className={"util-padding-top-20"}>
              <Col>
                <table data-testid={"management_table"} id={"management_table"}>
                  {refreshData["label"] === "Custody Account" ? (
                    <colgroup>
                      <col style={{ width: 15 }} />
                      <col style={{ width: 10 }} />
                    </colgroup>
                  ) : (
                    <colgroup>
                      <col style={{ width: 25 }} />
                      <col style={{ width: 25 }} />
                    </colgroup>
                  )}
                  <thead>
                    {tabeDateFilesReceived.getHeaderGroups().map((headerGroup) => (
                      <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                          <th key={header.id}>
                            {header.isPlaceholder
                              ? null
                              : flexRender(header.column.columnDef.header, header.getContext())}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody>
                    {dataDateFilesReceived.length < 1 ? (
                      <>
                        <tr>
                          {columns.map((col, index) => (
                            <td key={index}>&#8205;</td>
                          ))}
                        </tr>
                      </>
                    ) : (
                      <>
                        {tabeDateFilesReceived.getRowModel().rows.map((row) => (
                          <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => (
                              <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                            ))}
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
            <Pagination
              data={dataDateFilesReceived}
              table={tabeDateFilesReceived}
              setPageViewNum={setPageViewNum}
              pageViewNum={pageViewNum}
              getPageViewOption={getPageViewOption}
            ></Pagination>
          </>
        ) : (
          <>
            <h2 className="text-center"> Application is starting</h2>
            <Loading></Loading>
          </>
        )}
      </Col>
    </div>
  );
};

export default DateFilesReceivedManagement;
